/**
 * Debounced ResizeObserver for lightweight-charts.
 * Avoids "ResizeObserver loop" warnings when chart resizes trigger layout churn.
 */
export function observeChartSize(container, applySize) {
  if (!container || typeof container !== 'object' || !container.nodeType) {
    return () => {};
  }

  let frame = null;

  const ro = new ResizeObserver((entries) => {
    if (frame) {
      cancelAnimationFrame(frame);
    }
    // Double rAF: run after layout/paint so chart resize does not re-enter the observer in the same turn.
    frame = requestAnimationFrame(() => {
      frame = requestAnimationFrame(() => {
        frame = null;
        for (const entry of entries) {
          const { width, height } = entry.contentRect;
          if (width > 0 && height > 0) {
            applySize(width, height);
          }
        }
      });
    });
  });

  ro.observe(container);

  return () => {
    if (frame) {
      cancelAnimationFrame(frame);
    }
    ro.disconnect();
  };
}
